import { type FunctionComponent, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'

import { useKindeCookies } from '../../../routes/components/Page'
import { Loader } from '../../../shared'
import { useBaseMetaTags } from '../../../shared/hooks/useBaseMetaTags'
import { ErrorModal } from '../components/ErrorModal'

const LoginRedirectPage: FunctionComponent = () => {
  const { getBaseMetaTags } = useBaseMetaTags()
  useKindeCookies()
  const [showManualRedirect, setShowManualRedirect] = useState(false)
  const [backupRedirect, setBackupRedirect] = useState('/')

  const metaTagObj = {
    canonical: 'https://www.which.co.uk/login-redirect',
    title: 'Login redirecting',
    desc: 'Redirecting after login',
  }

  const getMetaTags = ({ meta, imageUrl, twitterCard }) => [
    ...getBaseMetaTags({ meta, imageUrl, twitterCard }),
  ]
  useEffect(() => {
    setBackupRedirect(sessionStorage.getItem('kindeRedirect') || '/')
    const timer = setTimeout(() => {
      setShowManualRedirect(true)
    }, 5000)

    return () => clearTimeout(timer)
  }, [])

  return (
    <>
      <Helmet>
        {getMetaTags({
          meta: metaTagObj,
          imageUrl: 'https://www.which.co.uk/login',
          twitterCard: 'summary_large_image',
        })}
        <meta content="noindex" name="robots" />
      </Helmet>
      <Loader />
      <ErrorModal
        httpErrorCode={'408'}
        showModal={showManualRedirect}
        setShowModal={setShowManualRedirect}
        hrefLink={backupRedirect}
      />
    </>
  )
}

export default LoginRedirectPage
